import { Pipe, PipeTransform } from '@angular/core';

import {
  FormattedTableCell,
  formatTableCell,
  TableColumnLike,
  tableLeafTitles,
} from './table-cell-format.util';

/**
 * Formats a user-built table cell for display (see table-cell-format.util).
 * Pass the cell's column title, or the table's columns plus the cell index:
 *
 *   <td [class.text-end]="(cell | tableCell: table.columns : i).numeric">
 *     {{ (cell | tableCell: table.columns : i).text || '-' }}
 *   </td>
 */
@Pipe({
  name: 'tableCell',
  standalone: true,
})
export class TableCellPipe implements PipeTransform {
  transform(
    value: unknown,
    column?: string | null | TableColumnLike[],
    cellIndex?: number,
  ): FormattedTableCell {
    const title = Array.isArray(column)
      ? tableLeafTitles(column)[cellIndex ?? -1]
      : column;

    return formatTableCell(value, title);
  }
}
